import {
  ExperienceTransferItem, ExperienceTransferItemValidation
} from './types-store';

export const ACTION = {
  REQUEST_EXPERIENCE_TRANSFER: 'EXPERIENCE_TRANSFER_FORM:REQUEST_EXPERIENCE_TRANSFER',
  RECEIVE_EXPERIENCE_TRANSFER: 'EXPERIENCE_TRANSFER_FORM:RECEIVE_EXPERIENCE_TRANSFER',
  FAIL_EXPERIENCE_TRANSFER: 'EXPERIENCE_TRANSFER_FORM:FAIL_EXPERIENCE_TRANSFER',

  REQUEST_DELETE_EXPERIENCE_TRANSFER: 'EXPERIENCE_TRANSFER_FORM:REQUEST_DELETE_EXPERIENCE_TRANSFER',
  RECEIVE_DELETE_EXPERIENCE_TRANSFER: 'EXPERIENCE_TRANSFER_FORM:RECEIVE_DELETE_EXPERIENCE_TRANSFER',
  FAIL_DELETE_EXPERIENCE_TRANSFER: 'EXPERIENCE_TRANSFER_FORM:FAIL_DELETE_EXPERIENCE_TRANSFER',

  REQUEST_SAVE_EXPERIENCE_TRANSFER: 'EXPERIENCE_TRANSFER_FORM:REQUEST_SAVE_EXPERIENCE_TRANSFER',
  RECEIVE_SAVE_EXPERIENCE_TRANSFER: 'EXPERIENCE_TRANSFER_FORM:RECEIVE_SAVE_EXPERIENCE_TRANSFER',
  FAIL_SAVE_EXPERIENCE_TRANSFER: 'EXPERIENCE_TRANSFER_FORM:FAIL_SAVE_EXPERIENCE_TRANSFER',

  UPDATE_ITEM: 'EXPERIENCE_TRANSFER_FORM:UPDATE_ITEM',

  CLEAR_FORM: 'EXPERIENCE_TRANSFER_FORM:CLEAR_FORM',
  UPDATE_VALIDATION: 'EXPERIENCE_TRANSFER_FORM:UPDATE_VALIDATION',
  RESET_VALIDATION: 'EXPERIENCE_TRANSFER_FORM:RESET_VALIDATION',
  CLEAR_VALIDATION: 'EXPERIENCE_TRANSFER_FORM:CLEAR_VALIDATION'
};

export class RequestExperienceTransfer {
  public type: string = ACTION.REQUEST_EXPERIENCE_TRANSFER;
}

export class ReceiveExperienceTransfer {
  public type: string = ACTION.RECEIVE_EXPERIENCE_TRANSFER;
  constructor(
    public item: ExperienceTransferItem
  ) { }
}

export class FailExperienceTransfer {
  public type: string = ACTION.FAIL_EXPERIENCE_TRANSFER;
}

export class RequestDeleteExperienceTransfer {
  public type: string = ACTION.REQUEST_DELETE_EXPERIENCE_TRANSFER;
}

export class ReceiveDeleteExperienceTransfer {
  public type: string = ACTION.RECEIVE_DELETE_EXPERIENCE_TRANSFER;
}

export class FailDeleteExperienceTransfer {
  public type: string = ACTION.FAIL_DELETE_EXPERIENCE_TRANSFER;
}

export class RequestSaveExperienceTransfer {
  public type: string = ACTION.REQUEST_SAVE_EXPERIENCE_TRANSFER;
}

export class ReceiveSaveExperienceTransfer {
  public type: string = ACTION.RECEIVE_SAVE_EXPERIENCE_TRANSFER;
}

export class FailSaveExperienceTransfer {
  public type: string = ACTION.FAIL_SAVE_EXPERIENCE_TRANSFER;
}

export class ClearForm {
  public type: string = ACTION.CLEAR_FORM;
}

export class UpdateItem {
  public type: string = ACTION.UPDATE_ITEM;
  constructor(public item: Partial<ExperienceTransferItem>) { }
}

export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: ExperienceTransferItemValidation) { }
}

export class ResetValidation {
  public type: string = ACTION.RESET_VALIDATION;
  constructor(public id: number, public key?: string) {
  }
}

export class ClearValidation {
  public type: string = ACTION.CLEAR_VALIDATION;
}
